import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LIMIT } from '../../../../../shared/constants/asset-limit.constant';

export interface AssetLimitModalData {
    limit: number,
    total: number
}

@Component({
    templateUrl: './asset-limit-modal.component.html',
    styles: [`:host ::ng-deep .mdc-dialog__title+.mdc-dialog__content {
                padding: 24px;
            }

            ::ng-deep .mat-mdc-dialog-container .mdc-dialog__content {
                color: black;
                letter-spacing:unset;
            }
            :host ::ng-deep .mat-mdc-slide-toggle .mdc-label {
                font-size: 16px;
            } `],
    standalone: false
})
export class AssetLimitModalComponent implements OnInit {
    title: string = null;
    message: string = null;
    allowUnlimited: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) private data: AssetLimitModalData, public dialogRef: MatDialogRef<AssetLimitModalComponent>) { }

    ngOnInit() {
        this.message = `Default settings allow for a maximum of ${LIMIT} assets to be displayed.`;
        this.allowUnlimited = this.data.limit > 0 ? false : true;
    }

    save() {
        this.dialogRef.close({ limit: this.allowUnlimited ? -1 : LIMIT });
    }
}

